import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private numMessagesUnreadSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  constructor() {}

  getNumMessagesUnread(): Observable<string> {
    return this.numMessagesUnreadSubject.asObservable();
  }

  setNumMessagesUnread(numMessages: number): void {
    if (numMessages > 0) {
      const displayValue = numMessages > 9 ? '+9' : numMessages.toString();
      this.numMessagesUnreadSubject.next(displayValue);
    }
  }
}
